// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import {getAccountLevelDisplay} from '../../../../../../Utils/accountLevelUtils'
import '../../../../../../Utils/accountLevel.css'

const getUsersColumns = (userType?: string): ReadonlyArray<Column<User>> => [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => (
      <UserSelectionCell
        id={props.data[props.row.index].code}
        accountStatus={props.data[props.row.index].accountStatus}
      />
    ),
  },
  ...(userType === 'INTERPRETER'
    ? [
        {
          Header: 'User ID',
          accessor: 'userId',
        } as Column<User>,
      ]
    : []),
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  ...(userType === 'CONSUMER'
    ? [
        {
          Header: (props) => (
            <UserCustomHeader tableProps={props} title='IVR PIN' className='min-w-100px' />
          ),
          id: 'ivrPin',
          Cell: ({...props}) => {
            const user = props.data[props.row.index]
            return <span>{user.pinCodeString || '-'}</span>
          },
        } as Column<User>,
      ]
    : []),
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
    accessor: 'role',
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Customer' className='min-w-125px' />
    ),
    accessor: 'customerName',
  },

  /*{
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    accessor: 'accountStatus',
  }*/ {
    Header: (props) => <UserCustomHeader tableProps={props} title='Status' />,
    id: 'accountStatus',
    Cell: ({...props}) => {
      const row = props.data[props.row.index]
      const isInactive = (row.email && row.isdeleted) || row.accountStatus === 'Not Active'
      const hasNeverLoggedIn = !row.lastLoginDate
      const isPending = !row.isConfirmed

      return (
        <>
          {isInactive ? (
            <span
              className='badge badge-light-danger px-3 py-2 fs-9 d-flex align-items-center justify-content-center'
              style={{width: '80px'}}
            >
              Inactive{' '}
            </span>
          ) : isPending ? (
            <span
              className='badge badge-light-warning px-3 py-2 fs-9 d-flex align-items-center justify-content-center'
              style={{width: '80px'}}
            >
              Pending
            </span>
          ) : (
            <span
              className='badge badge-light-success px-3 py-2 fs-9 d-flex align-items-center justify-content-center'
              style={{width: '80px'}}
            >
              Active
            </span>
          )}
        </>
      )
    },
  },
  ...(userType === 'CONSUMER'
    ? [
        {
          Header: (props) => <UserCustomHeader tableProps={props} title='Account Level' />,
          id: 'accountLevel',
          Cell: ({...props}) => {
            const display = getAccountLevelDisplay(props.data[props.row.index].accountLevel)
            if (!display) {
              return <span>-</span>
            }
            return (
              <span
                className={`badge account-level-badge ${display.badgeClass} px-3 py-2 fs-9 d-flex align-items-center justify-content-center`}
              >
                {display.label}
              </span>
            )
          },
        } as Column<User>,
      ]
    : []),
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Last login' className='min-w-125px' />
    ),
    id: 'lastLoginDate',
    Cell: ({...props}) => (
      <UserLastLoginCell last_login={props.data[props.row.index].lastLoginDate} />
    ),
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Joined Date' className='min-w-125px' />
    ),
    accessor: 'join_date',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <UserActionsCell
        isConfirmed={props.data[props.row.index].isConfirmed}
        code={props.data[props.row.index].code}
        email={props.data[props.row.index].email}
        accountStatus={props.data[props.row.index].accountStatus}
      />
    ),
  },
]

export {getUsersColumns}
